import { useState } from 'react';
import { useLanguage } from '../context/LanguageContext';
import { translations } from '../data/translations';
import { Menu, X, Hexagon } from 'lucide-react';

const Header = ({ scrollToContact }) => {
  const { language, toggleLanguage, t } = useLanguage();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const navItems = [
    { key: 'services', href: '#services' },
    { key: 'packages', href: '#packages' },
    { key: 'testimonials', href: '#testimonials' },
    { key: 'contact', href: '#contact' },
  ];

  return (
    <header className="fixed top-0 left-0 right-0 z-50 glass" data-testid="header">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <a href="#" className="flex items-center gap-3" data-testid="logo">
            <div className="relative">
              <Hexagon className="w-10 h-10 text-emerald-500" strokeWidth={1.5} />
              <span className="absolute inset-0 flex items-center justify-center text-white font-bold text-sm">360</span>
            </div>
            <div className="hidden sm:block">
              <span className="text-white font-bold text-lg tracking-tight">360Gaming</span>
              <span className="text-emerald-500 font-bold text-lg tracking-tight"> Solutions</span>
            </div>
          </a>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-8">
            {navItems.map((item) => (
              <a
                key={item.key}
                href={item.href}
                className="nav-link text-sm font-medium"
                data-testid={`nav-${item.key}`}
              >
                {t(translations.nav[item.key])}
              </a>
            ))}
          </nav>

          {/* Language Toggle & CTA */}
          <div className="flex items-center gap-4">
            <div className="lang-toggle" data-testid="language-toggle">
              <button
                onClick={() => language !== 'en' && toggleLanguage()}
                className={`lang-btn ${language === 'en' ? 'active' : ''}`}
                data-testid="lang-en"
              >
                EN
              </button>
              <button
                onClick={() => language !== 'gr' && toggleLanguage()}
                className={`lang-btn ${language === 'gr' ? 'active' : ''}`}
                data-testid="lang-gr"
              >
                GR
              </button>
            </div>
            
            <button
              onClick={() => scrollToContact()}
              className="hidden md:block btn-primary text-sm"
              data-testid="header-cta"
            >
              {t(translations.hero.cta)}
            </button>

            {/* Mobile Menu Button */}
            <button
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              className="md:hidden p-2 text-white"
              data-testid="mobile-menu-btn"
            >
              {mobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="md:hidden py-4 border-t border-white/10" data-testid="mobile-menu">
            <nav className="flex flex-col gap-4">
              {navItems.map((item) => (
                <a
                  key={item.key}
                  href={item.href}
                  onClick={() => setMobileMenuOpen(false)}
                  className="text-white/70 hover:text-white py-2 text-sm font-medium"
                  data-testid={`mobile-nav-${item.key}`}
                >
                  {t(translations.nav[item.key])}
                </a>
              ))}
              <button
                onClick={() => {
                  scrollToContact();
                  setMobileMenuOpen(false);
                }}
                className="btn-primary text-sm mt-2"
                data-testid="mobile-cta"
              >
                {t(translations.hero.cta)}
              </button>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
